import React from "react";
import { Children } from "react";
import { createPortal } from "react-dom";

export default function OutNode({children}) {
  return createPortal(<>{children}</>, document.body);
}
